// extracted by mini-css-extract-plugin
export default {"wrapper":"item-skeleton-list__wrapper___pfwa9","button":"item-skeleton-list__button___P_7sz","skeletonAnimation":"item-skeleton-list__skeletonAnimation___hXmfT"};